import fetcher from 'modules/fetcher'

export const get = (key) => {
  return fetcher(`/api/v3/user_settings/${key}`)
}

export const update = (key, userSettings) => {
  return fetcher(`/api/v3/user_settings/${key}`, {
    method: 'PUT',
    body: JSON.stringify({ user_setting: userSettings })
  })
}
